export default __webpack_public_path__ + "static/media/inputBar.0da80717.svg";